import template from './bargain-price.jade';

export default angular
    .module('cian.addForm.bargainPrice', [])
    .directive('cianAfPriceAndDealTermsBargainPrice', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {},
        controllerAs: 'bargainPrice',
        template,
    }))
    .name;
